<template>
  <div class="fps-score-wrapper">
    <div class="fps-score-header">
      <h2 class="fps-score-title">FPS Score</h2>
      <p class="fps-score-description">
        FPS Score progress toont het % ingevulde vragen door alle deelnemers. 100% is het doel.
      </p>
      <div class="countdown-text" v-if="countdownText && countdownText !== ''">
        {{ countdownText }}
      </div>
    </div>
    <div class="left-score-side" :class="{ loading: !removeLoading }">
      <transition name="fade">
        <div class="loading-overlay" v-if="!removeLoading">
          <div class="score-bar-wrapper">
            <div class="score-bar">
              <div class="score-bar-fill" :style="{ width: `${totalScore}%` }">
                <span class="score-text">{{ totalScore }}%</span>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="img-wrapper">
        <!-- <img src="@/assets/images/fps-score-example.png" alt="FPS score" /> -->
        <template v-if="checkResults('aca09f18-7e03-4a73-89d5-04ffb4d7c6cd')">
          <VisualizeData
            :data="checkResults('aca09f18-7e03-4a73-89d5-04ffb4d7c6cd')"
            :type="'gauge'"
            :decimalAmount="1"
            :animation="!removeLoading ? false : true"
          />
        </template>
      </div>
    </div>
    <div class="right-score-side" :class="{ loading: !removeLoading }">
      <!-- FPI_Score -->
      <div class="score-table-wrapper" v-if="checkResults('6e3119c5-844e-442f-9574-9e336686c038')">
        <VisualizeData
          :data="checkResults('6e3119c5-844e-442f-9574-9e336686c038')"
          :type="'table'"
          :extraClass="'fpi-score'"
          :enableDetailPage="true"
          :decimalAmount="1"
        />
      </div>
    </div>

    <div class="button-wrapper" v-if="removeLoading">
      <router-link class="button" to="/resultaten/fps-score/resultaat">
        Bekijk je resultaten
      </router-link>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted } from 'vue'

import { useAuthenticationData } from '@/composables/useAuthenticationData'

import { useGlobalStore } from '@/stores/global'
import { useCurrentUserData } from '@/composables/useUserData'

import { useTrainingLoadingState } from '@/composables/useTrainingLoadingState'

import { fetchTrainingProgressOverview } from '@streampac.io/chef_sp_1'

import { fetchCalculationData } from '@streampac.io/chef_sp_1'

import { resolveEnum } from '@/utils/global'

import VisualizeData from '@/components/VisualizeData/index.vue'

export default defineComponent({
  components: {
    VisualizeData
  },
  props: {},
  setup(props) {
    const isAuthenticated = computed(() => {
      return useAuthenticationData().data.value.isAuthenticated
    })

    const totalScore = ref(0)

    const trainingDoneAndClosed = ref(false)

    const responseData = ref(null)

    //const calculationData = ref({})

    const calculationData = ref({
      'aca09f18-7e03-4a73-89d5-04ffb4d7c6cd': {
        filters: {},
        results: [
          {
            calculationResultValue: 6.5
          }
        ],
        name: 'FPS_Total_Score'
      },
      '6e3119c5-844e-442f-9574-9e336686c038': {
        filters: {},
        results: [
          {
            calculationResultValue: 1.2,
            calculationNorm: 0,
            calculationValueLabel: 'FPI 1',
            sortOrder: 10600
          },
          {
            calculationResultValue: 1.4,
            calculationNorm: 0,
            calculationValueLabel: 'FPI Culture 2',
            sortOrder: 10600
          },
          {
            calculationResultValue: 2.2,
            calculationNorm: 0,
            calculationValueLabel: 'FPI Culture fa 3',
            sortOrder: 10600
          },
          {
            calculationResultValue: 1.4,
            calculationNorm: 0,
            calculationValueLabel: 'FPI Culture 4',
            sortOrder: 10600
          },

          {
            calculationResultValue: 1.2,
            calculationNorm: 0,
            calculationValueLabel: 'FPI Culture fifi 5',
            sortOrder: 10600
          },
          {
            calculationResultValue: 3.4,
            calculationNorm: 0,
            calculationValueLabel: 'FPI Culture 6',
            sortOrder: 10600
          },

          {
            calculationResultValue: 0.2,
            calculationNorm: 0,
            calculationValueLabel: 'FPI Culture 7',
            sortOrder: 10600
          },
          {
            calculationResultValue: 1.4,
            calculationNorm: 0,
            calculationValueLabel: 'FPI Culture tmp 8',
            sortOrder: 10600
          }
        ],
        name: 'FPI_Score'
      }
    })

    const gotDataForVisualisation = ref([])

    const { getCurrentUser } = useCurrentUserData()

    const globalStore = useGlobalStore()

    const { removeLoading, countdownText } = useTrainingLoadingState({
      trainingDoneAndClosed,
      gotDataForVisualisation,
      getCurrentUser,
      responseData,
      expectedVisualisationCount: 2
    })

    const reverseCalcScore = () => {
      return 100 - totalScore.value
    }

    // watch(totalScore, () => {
    //   if (totalScore.value === 100) {
    //     // // FPS_Total_Score
    //     // getSpecificData('aca09f18-7e03-4a73-89d5-04ffb4d7c6cd', ['CustomerGroup'], [], [])
    //     // // FPI_Score
    //     // getSpecificData(
    //     //   '6e3119c5-844e-442f-9574-9e336686c038',
    //     //   ['UserLevel', 'CustomerGroup'],
    //     //   [],
    //     //   []
    //     // )
    //   }
    // })

    // watch(
    //   gotDataForVisualisation.value,
    //   () => {
    //     // console.log('gotDataForVisualisation', gotDataForVisualisation.value)
    //     if (gotDataForVisualisation.value.length === 2 && !trainingDoneAndClosed.value) {
    //       //removeLoading.value = true
    //     }
    //   },
    //   { deep: true }
    // )

    function fetchProgressData() {
      let fetchObjectParams = {
        //userId: 0,
        customerGroupID: getCurrentUser.value.customerGroupIds,
        userlevel: [getCurrentUser.value.level],
        trainingID: []
      }

      if (getCurrentUser.value.level == 1) {
        fetchObjectParams.userLevel = []
      }

      fetchTrainingProgressOverview(isAuthenticated.value, fetchObjectParams, '', true).then(
        (response) => {
          if (response && response.status === 200) {
            const totalActiveUsers = response.data.totalActiveUsers

            // Calculate total successful trainings
            const totalSuccessfulTrainings = response.data.trainingProgress.reduce(
              (sum, training) => {
                return sum + training.numberOfTrainingSuccessful
              },
              0
            )

            // Calculate total possible trainings (training types × active users)
            const totalPossibleTrainings = response.data.trainingProgress.length * totalActiveUsers

            // Calculate success percentage
            const calculatedScore =
              totalPossibleTrainings > 0
                ? Math.round((totalSuccessfulTrainings / totalPossibleTrainings) * 100)
                : 0

            //   console.log('Total successful trainings:', totalSuccessfulTrainings);
            //   console.log('Total possible trainings:', totalPossibleTrainings);
            //   console.log('Success rate:', (totalSuccessfulTrainings / totalPossibleTrainings) * 100);
            //   console.log('Final calculated score:', calculatedScore);

            trainingDoneAndClosed.value = response.data.trainingClosed

            //console.log(response.data)

            totalScore.value = calculatedScore

            responseData.value = response.data
          }
        }
      )
    }

    // watch(
    //   getCurrentUser.value,
    //   () => {
    //     fetchProgressData()
    //   },
    //   { deep: true }
    // )

    onMounted(() => {
      fetchProgressData()

      //FPI_Score
      getSpecificData(
        '6e3119c5-844e-442f-9574-9e336686c038',
        ['UserLevel', 'CustomerGroup'],
        [],
        []
      )
      // FPS_Total_Score
      getSpecificData('aca09f18-7e03-4a73-89d5-04ffb4d7c6cd', ['CustomerGroup'], [], [])

    })

    const getSpecificData = (visualisationId, dataLevels, userLevels, userIds) => {
      //console.log('go');
      let body = {
        dataLevels: dataLevels || ['user'],
        customerGroupIds: getCurrentUser.value.customerGroupIds || [],
        userLevels: userLevels || [],
        userIds: userIds || [],
        calculationMeta1: [],
        calculationMeta2: [],
        calculationMeta3: [],
        calculationMeta4: [],
        visualisationOption: visualisationId
      }

      fetchCalculationData(isAuthenticated.value, body, true).then((response) => {
        if (response?.status === 200) {
          if (response?.data?.results?.length > 0) {
            let data = {
              filters: response.data.filters,
              results: response.data.results,
              name: getEnumVal(visualisationId)
            }

            data.results.sort((a, b) => a.sortOrder - b.sortOrder)

            calculationData.value[visualisationId] = data

            //Add to array to check for total length later to remove loading
            gotDataForVisualisation.value.push(visualisationId)

            //console.log('calculationData', calculationData.value)
          }
        } else {
          console.log('error fetching calculationData', response)
        }
      })
    }

    function checkResults(visualisationId) {
      if (
        calculationData.value[visualisationId] &&
        calculationData.value[visualisationId].results.length > 0
      ) {
        return calculationData.value[visualisationId]
      }
      return false
    }

    function getEnumVal(val) {
      return resolveEnum(val)
    }

    // Timezone as GMT/UTC
    // const countdownText = computed(() => {
    //   if (!responseData.value?.trainingclosingdateandtime) {
    //     return ''
    //   }

    //   // Treat the date string as GMT/UTC by appending 'Z'
    //   const dateString = responseData.value.trainingclosingdateandtime
    //   const utcDateString = dateString.endsWith('Z') || dateString.includes('+') || dateString.includes('-', 10)
    //     ? dateString
    //     : `${dateString}Z`
      
    //   const closingDate = new Date(utcDateString)
    //   const now = currentTime.value
    //   const difference = closingDate.getTime() - now.getTime()

    //   if (difference <= 0) {
    //     return ''
    //   }

    //   const days = Math.floor(difference / (1000 * 60 * 60 * 24))
    //   const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    //   const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
    //   const seconds = Math.floor((difference % (1000 * 60)) / 1000)

    //   const parts = []
    //   if (days > 0) parts.push(`${days} ${days === 1 ? 'dag' : 'dagen'}`)
    //   if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'uur' : 'uur'}`)
    //   if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'minuut' : 'minuten'}`)
    //   if (parts.length === 0 && seconds > 0)
    //     parts.push(`${seconds} ${seconds === 1 ? 'seconde' : 'seconden'}`)

    //   return parts.length > 0 ? `Nog ${parts.join(', ')} te gaan` : ''
    // })

    return {
      isAuthenticated,
      getCurrentUser,
      totalScore,
      reverseCalcScore,
      removeLoading,
      checkResults,
      calculationData,
      getEnumVal,
      countdownText
    }
  }
})
</script>
<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
